<template>
    <div v-if="isUserAuthenticated()">
        <v-dialog persistent scrollable :value="value" @input="$emit('input', $event)" max-width="1000px">
            <v-card>
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text style="padding-top:0px;padding-bottom:0px;height:600px;">
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <div id="divPrint">
                        <div v-html="contractsHtml"></div>
                      </div>
                    </v-layout>
                  </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
                <v-btn color="blue darken-1" flat @click.native="print">Imprimer</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import APIReport from '@/api/report'
const APIReportService = new APIReport();

var axios = require('axios')

export default {
   props: {
    ID: { type: Number, required: false },
    value: { type: Boolean, required: true },
  },
  components:
  {
    TemplateAdminComponent
  },

  mounted() {
    this.$refs.form.resetValidation()
    //$('#date').datepicker()
    //$('#date').hide();
    //this.initialize()
    //debugger;
  },

  data() {
    //debugger;
    return {
        loading: false,
        search: '',
        pagination: {
          sortBy: 'Name',
          page: 1,
          rowsPerPage: 10
        },
        headers : [
          { text: 'Période', value: 'Period.Name', align: 'left' },
          { text: 'Secteur', value: 'Customer.AddressSnowRemoval.Street.Sector', align: 'left' },
          { text: 'Appartement', value: 'Customer.AddressSnowRemoval.AptNumber', align: 'left' },
          { text: 'Adresse à déneiger', value: 'Customer.AddressSnowRemoval.FullAddress', align: 'left' },
          { text: 'Nom à facturer', value: 'BillToName', align: 'left' },
          { text: 'Numéro de client', value: 'Customer.AddressSnowRemoval.AddressCustomerNumber', align: 'left' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        valid: false,
        requiredRules: [
          (v) => !!v || 'Field is required.',
        ],
        //items: [],
        transmissiontypeitems: [],
        paymentmethodtypeitems: [],
        editedItem: {},
        defaultItem: {},
        contractsHtml: ""
    }
  },

  computed: {
    formTitle () {
      return 'Liste des contrats'
    }
  },

    watch: {
    ID () {
      this.initialize()
    }
  },

  created(){
    this.initialize()
    //alert("created")
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize () {
      //debugger
      if (this.ID > 0)
      {
      //   APIService.get(this.ID).then(response =>  {
      //       //this.items = response.data
      //       this.editedItem = response.data
      //     }
      //   )
      }
      else if (this.ID == 0)
      {
        
        APIReportService.generateContractsHtml().then(response =>  {
            //debugger
            this.contractsHtml = response.data
          }
        )
      }

      // APITransmissionTypeService.getAll().then(response =>  {
      //       this.transmissiontypeitems = response.data
      //   }
      // )
    },

    close () {
      this.$emit('input', false)
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
    },

    print () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('divPrint').outerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      //WinPrint.close();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ModalPrintContracts.vue